import { CSSProperties } from 'react'

export const styleByFull: CSSProperties = {
  width: '100%',
  height: '100%',
}
